import React, { useState } from "react";
import type { BryntumTaskBoard } from "@bryntum/taskboard-react-thin";
import { Button } from "@procore/core-react";
import { Sliders } from "@procore/core-icons";
import type { Panel } from "@bryntum/core-thin";

function onConfigClick(
   setter: React.Dispatch<React.SetStateAction<boolean>>,
   taskBoardRef: React.RefObject<BryntumTaskBoard>,
) {
   const panel = taskBoardRef.current?.instance.widgetMap.right as Panel;
   if (panel.collapsing || panel.expanding) {
      return;
   }
   setter((cur) => !cur);
   panel.toggleCollapsed();
}

export function BoardsConfigButton({
   taskBoardRef,
}: {
   taskBoardRef: React.RefObject<BryntumTaskBoard>;
}) {
   const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);

   return (
      <Button
         variant="tertiary"
         icon={<Sliders size="sm" />}
         onClick={() => onConfigClick(setIsConfigPanelOpen, taskBoardRef)}
         className={isConfigPanelOpen ? "controlPanelButtonActive" : ""}
      />
   );
}
